<template>
<div>
  <a-card class="card-section" title="操作面板">
      <router-link to="/login"><a-button class="link-button" type="primary" ghost>控制台</a-button></router-link>
      <a-button disabled>注册</a-button>
  </a-card>
  <a-card class="card-section" title="最多浏览">
    <a-list item-layout="horizontal" :data-source="mostRead">
      <a-list-item slot="renderItem" slot-scope="item">
        <a-list-item-meta>
          <a slot="title" :href="item.indexTitle">{{ item.title }}</a>
        </a-list-item-meta>
        <div slot="extra">{{ item.createTime }}</div>
      </a-list-item>
    </a-list>
  </a-card>

  <a-card class="card-section" title="关于 About">
      <router-link class="card-link" to="/feedback" title="建议反馈">建议反馈</router-link>
      <router-link class="card-link" to="/about" title="关于本站">关于本站</router-link>
      <router-link class="card-link" to="/sitemap" title="网站地图">网站地图</router-link>
  </a-card>

  <a-card class="card-section" title="链接 Links">
      <a class="card-link" target="_blank" href="https://minio.fams.tech" title="对象存储">对象存储</a>
      <a class="card-link" target="_blank" href="https://gitea.fams.tech" title="暂已下线" disabled>私有Git服务</a>
  </a-card>
</div>
</template>

<script>
import axios from 'axios';
const mostRead = [];
export default {
  name: 'ContentRight',
  data() {
    return {
      mostRead
    };
  },
  created() {
    mostRead.splice(0, mostRead.length);
    var self = this;
    axios
      .get(self.GLOBAL.host + '/passage/mostRead')
      .then(response => {
        var res = response.data;
        if (res.code === 1000) {
          for (var index in res.data) {
            var passage = res.data[index];
            mostRead.push({
              title: passage.title,
              indexTitle: `/p/${passage.indexTitle}`,
              createTime: passage.createdTime.slice(0, 10)
            });
          }
        } else {
          self.$notification.error({
            message: '最多浏览查询失败',
            description: res.message
          });
        }
      })
      .catch(function (error) {
        self.$notification.error({
          message: '系统异常',
          description: error
        });
      });
  }
};
</script>

<style>
.card-section {
  margin: 10px 0 10px 0;
}

.link-button {
  margin-right: 20px;
}

.card-link {
  color: #555;
  padding: 10px;
}

.card-link:hover {
  color: #41b8e4;
}
</style>
